function getDeferredPromise<T>() {
  let resolve: (value: T) => void
  let reject: (reason?: unknown) => void
  const promise = new Promise<T>((resolve_, reject_) => {
    resolve = resolve_
    reject = reject_
  })
  return {
    promise,
    resolve: (value: T) => {
      resolve(value)
    },
    reject: (reason?: unknown) => {
      reject(reason)
    },
  }
}
export default getDeferredPromise
